import React from 'react';
import PageTemplate from '../../../components/template/PageTemplate';
import { RECOMMEND_TAG_PAGE_NAME } from '../../../constants/service/app/recommendTagConstants';
import RecommendTagListContainer from '../../../containers/recommend/tag/RecommendTagListContainer';

const RecommendTagList = () => {
  return (
    <PageTemplate pageName={RECOMMEND_TAG_PAGE_NAME.RECOMMEND_TAG_LIST}>
      <RecommendTagListContainer />
    </PageTemplate>
  );
};

export default RecommendTagList;
